import { withTheme } from 'styled-components'

export const IconX = withTheme(({ theme, ...props }) => (
	<svg {...props} width='24' height='24' viewBox='0 0 24 24' fill='currentcolor' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M13.3637 11.9623L17.6067 7.71931C17.8667 7.46824 17.9709 7.09644 17.8794 6.74681C17.7879 6.39718 17.5149 6.12413 17.1652 6.03262C16.8156 5.9411 16.4438 6.04536 16.1927 6.30531L11.9497 10.5483L7.70773 6.30531C7.45514 6.05255 7.08689 5.95374 6.7417 6.0461C6.3965 6.13846 6.1268 6.40797 6.0342 6.7531C5.94159 7.09823 6.04014 7.46655 6.29273 7.71931L10.5357 11.9623L6.29273 16.2053C6.04014 16.4581 5.94159 16.8264 6.0342 17.1715C6.1268 17.5167 6.3965 17.7862 6.7417 17.8785C7.08689 17.9709 7.45514 17.8721 7.70773 17.6193L11.9497 13.3763L16.1927 17.6193C16.5851 17.9983 17.2088 17.9929 17.5945 17.6071C17.9803 17.2214 17.9857 16.5977 17.6067 16.2053L13.3637 11.9623Z'
		/>
	</svg>
))
